module.exports = __webpack_public_path__ + "static/media/LifeLine2.fba67a97.png";